import { Link } from 'react-router-dom';

import CtaBand from '../components/CtaBand';
import PageHero from '../components/PageHero';
import SectionHead from '../components/SectionHead';
import { usePageMeta } from '../hooks/usePageMeta';
import { useT } from '../i18n/LanguageProvider';

export default function AboutPage() {
  const t = useT();
  const copy = t.about;

  usePageMeta(copy.metaTitle, copy.metaDescription);

  return (
    <>
      <PageHero eyebrow={copy.heroEyebrow} title={copy.heroTitle} lead={copy.heroLead} />

      <section className="section">
        <div className="split">
          <div>
            <p className="eyebrow">{copy.differenceEyebrow}</p>
            <h2>
              {copy.differenceTitleTop}
              <br />
              {copy.differenceTitleBottom}
            </h2>
          </div>
          <div>
            <p className="lead">{copy.differenceLead}</p>
            <div className="principles">
              {copy.principles.map((principle) => (
                <div key={principle.title}>
                  <h4>{principle.title}</h4>
                  <p>{principle.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section paper">
        <SectionHead eyebrow={copy.profileEyebrow} title={copy.profileTitle} />
        <div className="profile">
          <div className="profile-card">
            <div className="avatar" aria-hidden="true">
              JE
            </div>
            <h3>Jan-Olof Eriksson</h3>
            <p className="role">{copy.profileRole}</p>
            <ul>
              {copy.profileFacts.map((fact) => (
                <li key={fact}>{fact}</li>
              ))}
            </ul>
          </div>
          <div>
            <p className="lead">{copy.profileLead}</p>
            <p>{copy.profileBody1}</p>
            <p>{copy.profileBody2}</p>

            <div className="stack">
              <h3>{copy.selectedExperience.title}</h3>
              <p>{copy.selectedExperience.body}</p>
              <p>
                <Link className="textlink" to="/case">
                  {copy.selectedExperienceLink}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section dark">
        <div className="split">
          <div>
            <p className="eyebrow light">{copy.principleEyebrow}</p>
            <h2>
              {copy.principleTitleTop}
              <br />
              {copy.principleTitleBottom}
            </h2>
          </div>
          <div>
            <p className="large">{copy.principleLarge}</p>
            <p>{copy.principleBody}</p>
            <p>
              <Link className="button ghost" to="/kontakt">
                {copy.principleLink}
              </Link>
            </p>
          </div>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
